import { Statuses } from '@wix/domains-search-suite';
import { MobileConnectOnDesktop } from '../../Components/StatusesOverrides/LoggedInMobile/MobileConnectOnDesktop';
const upgradeRequireConnectStatus = props => ({
  ...Statuses.upgradeRequireConnect(props),
  StatusComponent: MobileConnectOnDesktop,
  autoInvoke: false
});
export const mobileUpgradeRequireConnectStatus = upgradeRequireConnectStatus;
//# sourceMappingURL=mobileUpgradeConnectStatus.js.map